import React from 'react'
import Header from '../Components/Header/Header'
import Router from '../Routers/Router'
import TopHeader from '../Components/Header/TopHeader'
import Footer from '../Components/Footer'
import withDelay from '../Custom-Hooks/withDelay'






const Layout = () => {

  return (
    <div className=''>
        <TopHeader />
        <Header />
        <div className='overflow-hidden'>
            <Router />
        </div>
        <Footer />
    </div>
  )
}

export default withDelay (Layout)
